export const utcDateFormatTo12HrFormat = (utcFormatDate: string) => {
  const date = new Date(utcFormatDate);
  const formateddate = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
    .format(date)
    .replace("at", "|");
  return formateddate;
};


/** Format date string to separate date and time display parts */
export const formatDate = (dateStr: string): { datePart: string; timePart: string } => {
    try {
        const date = new Date(dateStr);
        const options: Intl.DateTimeFormatOptions = {
            day: "2-digit",
            month: "long",
            year: "numeric",
            weekday: "long",
        };
        const datePart = date.toLocaleDateString("en-US", options);
        const timePart = date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        return { datePart, timePart };
    } catch {
        return { datePart: dateStr, timePart: "" };
    }
};

/** Formats a date string to short date — e.g. "Mar 25" */
export const formatShortDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString([], { month: "short", day: "numeric" });
};

/** Formats a date string to time — e.g. "02:30 PM" */
export const formatTime = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};
